module.exports = __webpack_public_path__ + "img/BateriaPanel.bff19947.svg";